import moment from 'moment-timezone';

export const formatDate = (date) => {
    return moment(date).format('YYYY-MM-DD');
};

export const formatDateTime = (date) => {
    return moment(date).format('YYYY-MM-DD HH:mm');
};

export const formatUtcDateTime = (date) => {
    return moment.utc(date).format('YYYY-MM-DD HH:mm');
};

export const getTimestampInTimeZone = (date, format = 'YYYY-MM-DD HH:mm', timezone = 'Europe/Warsaw') => {
    const momentDate = moment.utc(date, format).tz(timezone, true);
    momentDate.subtract(moment().utcOffset() - momentDate.utcOffset(), 'minutes');
    return momentDate.format('X');
};

export const formatTimeObject = (data) => {
    let timeString = '';

    if (data.HH === '') {
        timeString += '00';
    } else {
        timeString += data.HH;
    }

    timeString += ':';

    if (data.mm === '') {
        timeString += '00';
    } else {
        timeString += data.mm;
    }

    return timeString;
};

export const minutesBetween = (firstDate, secondDate) => {
    return moment(firstDate).diff(moment(secondDate), 'minutes');
};
